import { Form } from 'antd'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { YesNoSwitch } from '../../../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../../../constants/constants'
import { useAlgorithmRunDetails } from '../../../../../../hooks'
import { AlgorithmRunCompensationMatrixAnalysisConfig } from '../../../../../../store/reducers/workspaceReducer'

const CompensationMatrixAnalysisLastConfigurationModalStep = () => {
  const { workspaceId, algorithmRunId } = useParams()
  const { selectedAlgorithmRun } = useAlgorithmRunDetails({
    algorithmRunId,
    workspaceId,
    preventFetch: true,
  })

  const config: AlgorithmRunCompensationMatrixAnalysisConfig | undefined =
    useMemo(
      () =>
        selectedAlgorithmRun?.config as AlgorithmRunCompensationMatrixAnalysisConfig,
      [selectedAlgorithmRun],
    )

  return (
    <>
      <Form.Item
        name="ssr"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.ssr',
        )}
        required
      >
        {config?.ssr || NO_DATA_PLACEHOLDER}
      </Form.Item>
      <Form.Item
        name="experimentName"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.experimentName',
        )}
        required
      >
        {config?.experimentName || NO_DATA_PLACEHOLDER}
      </Form.Item>
      <Form.Item
        name="manuallySelectExperimentRun"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.experimentRunsToggle',
        )}
        required
      >
        <YesNoSwitch checked={config?.manuallySelectExperimentRun} disabled />
      </Form.Item>
      <Form.Item
        name="selectedExperimentRuns"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.selectExperimentRuns',
        )}
        required
      >
        {config?.selectedExperimentRuns?.join(' ') || NO_DATA_PLACEHOLDER}
      </Form.Item>
      <Form.Item
        name="manuallySelectSubjectIds"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.subjectIdsToggle',
        )}
        required
      >
        <YesNoSwitch checked={config?.manuallySelectExperimentRun} disabled />
      </Form.Item>
      <Form.Item
        name="selectedSubjectIds"
        label={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.selectSubjectIds',
        )}
        required
      >
        {config?.selectedExperimentRuns?.join(' ') || NO_DATA_PLACEHOLDER}
      </Form.Item>
    </>
  )
}

export default CompensationMatrixAnalysisLastConfigurationModalStep
